import { useState } from 'react';

import TextInput from '@/components/Forms/TextInput';
import { ClientButton } from '@/components/UI/Button';

import ChangePasswordForm from './ChangePasswordForm';

/**
 * The password row. Collapsed by default to a masked read-only field with a
 * "Change" link (matching the primary email's read-only + Edit treatment);
 * clicking Change reveals the full ChangePasswordForm with a Cancel to collapse.
 */
export default function PasswordField() {
  const [editing, setEditing] = useState(false);

  if (editing) {
    return (
      <div className="space-y-3">
        <ChangePasswordForm />
        <ClientButton
          type="button"
          variant="link"
          size="baseline"
          onClick={() => setEditing(false)}
          className="p-0 font-medium text-zinc-500 no-underline hover:text-zinc-700 hover:underline dark:text-zinc-400 dark:hover:text-zinc-200"
        >
          Cancel
        </ClientButton>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <TextInput
        readOnly
        value="••••••••••••"
        aria-label="Password"
        className="max-w-sm cursor-default bg-zinc-50 text-zinc-600 dark:bg-white/5 dark:text-zinc-300"
      />
      <ClientButton
        type="button"
        variant="link"
        size="baseline"
        onClick={() => setEditing(true)}
        className="p-0 font-semibold text-zinc-700 no-underline hover:text-zinc-900 hover:underline dark:text-zinc-200 dark:hover:text-white"
      >
        Change
      </ClientButton>
    </div>
  );
}
